<template>
    <section
        v-show="dccInfo != null"
        role="alert"
        class="dcc__info"
    >        
        <div v-if="dccInfo.to == 'NGN'">
            <p v-if="state.locale === 'fr'">
                Cette transaction ({{ dccInfo.from }} {{ resolvedPreDccAmount || amount }}, frais inclus) a été convertie dans la devise de votre carte au taux de {{ dccInfo.to }}&nbsp;{{ dccInfo.rate }} à {{ dccInfo.from }}&nbsp;1. Vous serez facturé {{ dccInfo.to }}&nbsp;{{ formatMoney(resolvedAmount) }}
            </p>
            <p v-else>
                This transaction ({{ dccInfo.from }} {{ resolvedPreDccAmount || amount }}, fees inclusive) has been converted to your card's currency at a rate of {{ dccInfo.to }}&nbsp;{{ dccInfo.rate }} to {{ dccInfo.from }}&nbsp;1. You will be charged {{ dccInfo.to }}&nbsp;{{ formatMoney(resolvedAmount) }}
            </p>
        </div>

        <div v-if="dccInfo.to == 'ZAR'">
            <p v-if="state.locale === 'fr'">
                En poursuivant cette transaction, vous acceptez qu'elle soit convertie dans notre monnaie de référence ({{ dccInfo.to }}) à un taux de {{ dccInfo.from }}&nbsp;1 à {{ dccInfo.to }}&nbsp;{{ dccInfo.rate }}. Vous serez facturé {{ dccInfo.to }} {{ formatMoney(resolvedAmount) }}. Le fournisseur de votre carte peut vous facturer des frais de conversion supplémentaires.
            </p>
            <p v-else>
                By continuing with this transaction, you agree for it to be converted to our supported currency ({{ dccInfo.to }}) at a rate of {{ dccInfo.from }}&nbsp;1 to {{ dccInfo.to }}&nbsp;{{ dccInfo.rate }}. You will be charged {{ dccInfo.to }} {{ formatMoney(resolvedAmount) }}. You might be charged an extra conversion fee by your card provider.
            </p>
        </div>
    </section>
</template>
<script>
import { mapState } from "redux-vuex";
import { computed } from "vue";
import { formatMoney, getValueFromPath } from "@/support/helpers";
export default {
    name: "dcc-info",

    props: {
        dccInfo: {
            default: null,
            type: Object,
        },
        campaignInfo: {
            default: null,
            type: Object,
        },
        amount: {
            type: [Number, String],
        },
    },

    setup(props) {
        const resolvedAmount = computed(() => {
            return props.campaignInfo !== null && props.campaignInfo.apply_discount ? props.campaignInfo.new_amount : props.dccInfo.charge_amount;
        });

        const resolvedPreDccAmount = computed(() => {
            return props.campaignInfo !== null && props.campaignInfo.apply_discount ? props.campaignInfo.pre_dcc_amount : props.amount;
        });

        return {
            state: mapState({
                locale: (state) => getValueFromPath(state, "locale") || "en",
            }),
            formatMoney,
            resolvedAmount,
            resolvedPreDccAmount,
        };
    },
};
</script>
<style lang="scss" scoped>
    .dcc__info {
        width: 100%;
        
        background: #FFFDFB;
        border: 1px solid rgba(108, 108, 108, 0.15);
        box-sizing: border-box;
        border-radius: 4px;

        padding: 14px;
        color: $black-3;

        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;

        margin-bottom: 25px;
    }
</style>